import { cmsModule } from '../../Modules/Nzo.CMS/Frontend/cms.module'
import {
  applicationBuilder,
  GetApplicationPages,
  GetApplicationState,
} from '../../Shared/Frontend/application-discovery/module'

export const application = applicationBuilder
  .addModule(cmsModule)

type ApplicationBuilderState = typeof application
export type ApplicationState = GetApplicationState<ApplicationBuilderState>
export type ApplicationPages = GetApplicationPages<ApplicationBuilderState>
